"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subjects = exports.getCourse = exports.getCourseAPIKey = exports.courseAPIKeys = exports.courses = void 0;
var subjects_1 = require("./subjects");
Object.defineProperty(exports, "subjects", { enumerable: true, get: function () { return subjects_1.subjects; } });
/**
 * A convienience list of courses alone
 */
var courses = subjects_1.subjects.reduce(function (acc, subject) {
    return acc.concat(subject.courses);
}, []);
exports.courses = courses;
/**
 * A list of all valid course api keys - exported for convienience
 */
var courseAPIKeys = courses.map(function (course) {
    return course.apiKey;
});
exports.courseAPIKeys = courseAPIKeys;
/**
 * Gets a single course from the list of available courses
 * @param courseApiKeyString string which may be a valid course api key
 * @returns a single instance of Course
 */
var getCourse = function (courseApiKeyString) {
    var singleCourse = courses.find(function (course) { return course.apiKey === courseApiKeyString; });
    if (!singleCourse) {
        throw new Error("Unknown course api key supplied " + courseApiKeyString);
    }
    return singleCourse;
};
exports.getCourse = getCourse;
/**
 * Converts a string into a valid course api key (or throws an error)
 * @param courseApiKeyString string which may be a valid course api key
 */
var getCourseAPIKey = function (courseApiKeyString) {
    switch (courseApiKeyString) {
        case "mathematics":
        case "algebra-1":
        case "algebra-2":
        case "geometry":
        case "integrated-math-1":
        case "integrated-math-1-and-2":
        case "integrated-math-2":
        case "integrated-math-3":
        case "reading":
        case "reading-spanish":
        case "language-usage":
        case "earth-and-space-sciences":
        case "earth-space-and-life-sciences":
        case "life-sciences":
        case "physical-sciences":
        case "science-general-science": {
            return courseApiKeyString;
        }
        default: {
            throw new Error("Unknown course api key supplied " + courseApiKeyString);
        }
    }
};
exports.getCourseAPIKey = getCourseAPIKey;
//# sourceMappingURL=index.js.map